/* eslint no-underscore-dangle: ["error", { "allow": ["__queryID", "__position"] }] */
import MakePresenter from "presenters/MakePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import EcardPresenter from "presenters/EcardPresenter";
import { jjLogger } from "utils/logUtils";

import useSettings from "./useSettings";
import useAlgolia from "./useAlgolia";
import useAlgoliaTracker from "./useAlgoliaTracker";

const useAlgoliaEvents = () => {
  const {
    settings: { algolia },
  } = useSettings();
  const { getUserToken } = useAlgolia();
  const { setHitSelected, clearHitSelected, hitSelected } = useAlgoliaTracker();

  const trackEventAfterSearch = (item) => {
    try {
      window.aa("clickedObjectIDsAfterSearch", {
        userToken: getUserToken(),
        eventName: "click_on_after_search",
        index: algolia.indexName,
        queryID: item.__queryID,
        objectIDs: [item.objectID],
        positions: [item.__position],
      });
    } catch (error) {
      jjLogger.logError(`Failed to track click event: ${error}`);
    }

    setHitSelected(item);
  };

  const trackEventAfterSearchAndPurchase = (item) => {
    try {
      window.aa("convertedObjectIDsAfterSearch", {
        userToken: getUserToken(),
        eventName: "purchase_after_search",
        index: algolia.indexName,
        queryID: item.__queryID,
        objectIDs: [item.objectID],
      });
    } catch (error) {
      jjLogger.logError(`Failed to track purchase event: ${error}`);
    }
  };

  const trackPackPreviewAfterSearch = (morphablePackGroupSlug) => {
    if (morphablePackGroupSlug !== hitSelected?.objectID) return;

    try {
      window.aa("viewedObjectIDs", {
        userToken: getUserToken(),
        eventName: "pack_photo_preview_after_search",
        index: algolia.indexName,
        queryID: hitSelected.__queryID,
        objectIDs: [hitSelected.objectID],
      });
    } catch (error) {
      jjLogger.logError(`Failed to track pack preview event: ${error}`);
    }
  };

  const trackEventAfterSearchAndShare = (ecard) => {
    const templateGroupId = EcardPresenter.algoliaId(ecard);

    if (templateGroupId === hitSelected?.objectID) {
      try {
        window.aa("convertedObjectIDsAfterSearch", {
          userToken: getUserToken(),
          eventName: "share_after_search",
          index: algolia.indexName,
          queryID: hitSelected.__queryID,
          objectIDs: [hitSelected.objectID],
        });
      } catch (error) {
        jjLogger.logError(`Failed to track share event: ${error}`);
      }

      clearHitSelected();
    }
  };

  const trackEventAfterSearchAndMakeIsPreview = (ecard, templateGroup) => {
    const isMake = EcardPresenter.isMake(ecard);
    if (isMake && !MakePresenter.isDraft(ecard)) return;

    if (TemplateGroupPresenter.id(templateGroup) === hitSelected?.objectID) {
      try {
        window.aa("viewedObjectIDs", {
          userToken: getUserToken(),
          eventName: "make_preview_after_search",
          index: algolia.indexName,
          objectIDs: [hitSelected.objectID],
          queryID: hitSelected.__queryID,
        });
      } catch (error) {
        jjLogger.logError(`Failed to track make preview event: ${error}`);
      }
    }
  };

  return {
    trackEventAfterSearch,
    trackEventAfterSearchAndPurchase,
    trackEventAfterSearchAndShare,
    trackEventAfterSearchAndMakeIsPreview,
    trackPackPreviewAfterSearch,
  };
};

export default useAlgoliaEvents;
